// extracted by mini-css-extract-plugin
export default {"label":"CampaignCardStatus--label--450a85"};